import axios from 'axios';
import { getRolesUri } from '../utils/api';

const ROLES_URI = getRolesUri();

export async function getRoles(industry) {
  const { data } = await axios.get(ROLES_URI, { params: { industry } });
  return data;
}
